import type { ToastApi } from "@/ds";
import { getErrorMessage, isAPIError } from "@/core/services";
import { updateUserRole } from "@/modules/users";
import type { User } from "@/modules/users";
import {
  ROLE_UPDATE_ERROR_MESSAGE,
  ROLE_UPDATE_ERRORS,
  ROLE_UPDATE_SUCCESS_MESSAGE,
} from "../users.constants";

export interface UserRoleValues {
  readonly papelId: string;
}

interface UseUsersPerfilParams {
  readonly toast: ToastApi;
  /** Sucesso: a tela fecha o modal e refaz a consulta. */
  readonly onUpdated: () => void;
}

/** Model da atribuição e da troca de perfil (HU 721): só o perfil sai do formulário; a identidade é imutável (RN03). */
export function useUsersPerfil({ toast, onUpdated }: UseUsersPerfilParams) {
  /** Nunca rejeita: a falha mantém o modal aberto com a seleção feita. */
  return async (user: User, { papelId }: UserRoleValues): Promise<void> => {
    try {
      await updateUserRole({ id: user.id, papelId });
    } catch (error) {
      const known = isAPIError(error) ? ROLE_UPDATE_ERRORS[error.status] : undefined;

      toast.error(
        known?.summary ?? ROLE_UPDATE_ERROR_MESSAGE,
        known?.detail ?? getErrorMessage(error),
      );
      return;
    }

    onUpdated();
    toast.success("Sucesso", ROLE_UPDATE_SUCCESS_MESSAGE);
  };
}
